module.exports = __webpack_public_path__ + "img/bg_oats.d07ae15e.jpg";